<script setup lang="ts">
type OcsBrandLogo = {
  src: string
  alt: string
}

defineProps<OcsBrandLogo>()
</script>
<template>
  <img v-if="src" :alt="alt" :src="src" class="h-14" />
  <span
    v-else
    class="font-['Work Sans'] flex h-[3.75rem] items-center justify-center text-[2rem] font-bold md:h-16 md:max-w-52"
  >
    OCS
  </span>
</template>
